import { axios, store, removeLoginIfLogedOut, abortController } from './config/axios-config'
import deleteIncomplete from "./deleteIncomplete";

const getFilteredUserState = async () => {

    setTimeout(() =>{store.dispatch({ type: 'SET_STATUS_ERRO_CONEXAO', value: false })}, 0)

    console.log('[debug] getFilteredUserState', 'starting')
    let auxToken = localStorage.getItem("token")
    console.log('[debug] auxToken inside getFilteredUserState', auxToken)
    console.log('[debug] axios getFilteredUserState', axios)
    try {
        let response = await axios.get('/user/data/filteredSavedUserState',{
            cancelToken: abortController?.token
        })

        console.log('[debug] getFilteredUserState', response?.data, response, abortController?.token)
        console.log('[debug] getFilteredUserState axios', axios)


        let aux = response?.data?.filter(obj => obj.state.instituicaoSelecionada != "")

        try {
            let toDeleteList = response.data.filter(obj => obj.state.instituicaoSelecionada == "")
            if (toDeleteList.length > 0) {
                for (let toDeletObj of toDeleteList) {
                    console.log('delete', toDeletObj)
                    await deleteIncomplete(toDeletObj)
                }
            }
        } catch (err) {
            console.log("Error on deleting incomplete state", err)
        }





        // Criando um novo campo no Redux
        // store.dispatch({ type: 'SET_USER_SAVED_STATES_FILTERED', states: response.data })
        // store.dispatch({ type: 'SET_USER_SAVED_STATES', states: response.data })

        store.dispatch({ type: 'SET_USER_SAVED_STATES_FILTERED', states: aux })
        store.dispatch({ type: 'SET_USER_SAVED_STATES', states: aux })

        //return response.data
        return aux
        
        
    } catch (error) {
        console.log("[debug] getFilteredUserState error", error);

        if (error.response && error.response.status === 401) {
            console.log("[debug] Unauthorized - Token inválido ou expirado");

            // Aqui você pode redirecionar para login ou limpar token, por exemplo:
            removeLoginIfLogedOut(error);
            store.dispatch({ type: 'SET_STATUS_ERRO_CONEXAO', value: true });
        } else {
            // Lida com outros tipos de erro
            store.dispatch({ type: 'SET_STATUS_ERRO_CONEXAO', value: true });
        }

        store.dispatch({ type: 'SET_LOADING', loading: false });
    }

}

export default getFilteredUserState